import React from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';

const NoteSummary = ({editNote, note}) => {

  return <div className='notes__summary'>
    <div className='notes__summary__header'>
      <h3 className='notes__summary__title'>{note.name}</h3>
      <p className='notes__summary__subtitle'>
        <FormattedMessage id='notes.byline'
                          values={{author: note.author, date: moment(note.modified).format('ll')}} /></p>
      <button className='btn btn-icon notes__summary__edit' onClick={editNote(note)}>
        <i className='bl bl-edit' />
      </button>
    </div>
    <p className='notes__summary__body'>{note.body}</p>
  </div>;
};

export default NoteSummary;
